<template>
    <div class="empty">
        <span class="empty-text">{{ getTranslatedText(text) }}</span>
    </div>
</template>
<script>
import languageMixins from '@/mixins/language-mixins'

export default {
    mixins: [languageMixins],

    props: {
        text: {
            type: String,
            default: '',
        },
    },
}
</script>

<style lang="scss">
@import "@/public/scss/common/empty.scss";
</style>
